module.exports = __webpack_public_path__ + "74dc2bc77268762e2faa3475f8035be0.png";